import { FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All } from '../../../Queries/_QueryTypes/FakturaDelQuery';
import {
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaAttestSTATUSEnum,
} from '../../../../../../../../globalQueryTypes';
import FakturaDelContext, {
  IFakturaDelContext,
} from '../../FakturaDelContextManager/FakturaDelContext';
import { useState, useCallback, useContext } from 'react';
import { remove, uniqWith } from 'ramda';
import {
  IBusinessDataFormContext,
  BusinessDataFormContext,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import {
  mergeBusinessDataFormValues,
  IEditMenuActionParams,
  DisabledType,
  IFormData,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { LoginStateContext } from '../../../../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import {
  isAttesteraButtonDisabled,
  getAttesteraFakturadelUpdateValue,
} from '../../../Utils/FakturadelUtils';
import { FakturaattestWrapperContext } from '../../../../../Rutiner/FakturaDel/Contexts/FakturaattestWrapperContext';
import { ReservForQuery_db_LRAttestrattReserv_All } from '../../../../Attestant/Components/ReservFor/Queries/_QueryTypes/ReservForQuery';
import { generateMessageID } from '../../../../LeverantorFaktura/Utils/AttestMeddelandeUtils';

const getAutoCheckedAttestanterToReturnTo = (
  attestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  attestanterSomHarAttesterat: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]
): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] => {
  const beslutsAttestanterSomHarAttesterat = attestanterSomHarAttesterat.filter(
    attestant =>
      attestant.AttestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
  );
  const kontrollAttestanterSomHarAttesterat =
    attestanterSomHarAttesterat.filter(
      attestant =>
        attestant.AttestTyp === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
    );
  let autoCheckedAttestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] =
    [];

  if (
    attestanterToReturnTo.some(
      attestant =>
        attestant.AttestTyp ===
        TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST
    )
  ) {
    autoCheckedAttestanterToReturnTo = autoCheckedAttestanterToReturnTo.concat(
      beslutsAttestanterSomHarAttesterat
    );
  }
  if (
    attestanterToReturnTo.some(
      attestant =>
        attestant.AttestTyp === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
    ) ||
    autoCheckedAttestanterToReturnTo.some(
      attestant =>
        attestant.AttestTyp === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
    )
  ) {
    autoCheckedAttestanterToReturnTo = autoCheckedAttestanterToReturnTo.concat(
      kontrollAttestanterSomHarAttesterat
    );
  }

  return autoCheckedAttestanterToReturnTo;
};

export const getReturnFakturaDisabledReason = (
  attestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  message: string,
  returnToUtredningValue: ReturnToUtredningEnum | null,
  konteringValidationQueryLoading: boolean,
  businessDataFormContext: IBusinessDataFormContext<any>
): DisabledType => {
  if (returnToUtredningValue != null) {
    if (
      returnToUtredningValue === ReturnToUtredningEnum.withAttest &&
      businessDataFormContext != null
    ) {
      const actionParams: IEditMenuActionParams = {
        businessDataFormContext: businessDataFormContext,
        editMenuOnCancel: undefined,
      };

      const attesteraButtonDisabled = isAttesteraButtonDisabled(
        actionParams.businessDataFormContext,
        konteringValidationQueryLoading
      );

      if (attesteraButtonDisabled) {
        return attesteraButtonDisabled;
      }
    }
  } else if (attestanterToReturnTo.length === 0) {
    return 'Ange vem fakturan ska skickas tillbaka till';
  }

  if (!message) {
    return 'Ange ett meddelande';
  } else {
    return undefined;
  }
};

export const getAttestTypText = (
  attestTyp: TEDLRFakturaAttestAttestTypEnum | null
): string => {
  switch (attestTyp) {
    case TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST: {
      return 'Mottagningsattestant';
    }
    case TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST: {
      return 'Beslutsattestant';
    }
    case TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST: {
      return 'Kontrollattestant';
    }
    default: {
      return '';
    }
  }
};

const returnToAttestant = (
  fakturaDelContext: IFakturaDelContext,
  businessDataFormContext: IBusinessDataFormContext,
  attestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  message: string,
  setOpen: (open: boolean) => void
) => {
  const attestMessageUpdate: FormUpdateAssociatonType[][] =
    attestanterToReturnTo
      .map(
        (
          attestantToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
        ) => {
          const generatedID = generateMessageID();
          return fakturaDelContext.getAttestMessageUpdateValue(
            message,
            generatedID,
            undefined,
            attestantToReturnTo._Associations?.Attestratt?.id
          );
        }
      )
      .flat();

  const updateValue: Array<FormUpdateAssociatonType[]> =
    attestanterToReturnTo.map<FormUpdateAssociatonType[]>(
      attestantToReturnTo => {
        const updateValueArray: FormUpdateAssociatonType[] = [
          'Faktura',
          {
            operation: 'Update_Values',
            associationName: 'Fakturadel',
            id: businessDataFormContext?.data?.id ?? '',
          },
          {
            operation: 'Update_Values',
            associationName: 'Fakturaattest',
            id: attestantToReturnTo.id,
            values: {
              STATUS: 'UTDELAD',
              STATUS_DATUM: new Date().toLocaleDateString('sv-SE'),
              STATUS_TID: new Date().toLocaleTimeString('sv-SE'),
            },
          },
        ];

        return updateValueArray;
      }
    );

  businessDataFormContext?.saveForm(
    mergeBusinessDataFormValues(
      getFormUpdateValue(updateValue, businessDataFormContext.data ?? {}),
      getFormUpdateValue(
        attestMessageUpdate,
        businessDataFormContext.data ?? {}
      )
    ),
    () => {
      setOpen(false);
    }
  );
};

const returnToUtredning = (
  fakturaDelContext: IFakturaDelContext,
  businessDataFormContext: IBusinessDataFormContext,
  message: string,
  userSign: string,
  setOpen: (open: boolean) => void,
  returnToUtredningValue: ReturnToUtredningEnum | null,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
) => {
  const generatedID = generateMessageID();
  const attestMessageUpdate = fakturaDelContext.getAttestMessageUpdateValue(
    message,
    generatedID
  );

  const fakturadelStatusUtdelningValue = getFormUpdateValue(
    [
      {
        operation: 'OwnFields',
        values: {
          EXTRA_STATUS: 'R',
        },
      },
      {
        associationName: 'UtredningAttest',
        operation: 'Ref',
        id: fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?.id,
      },
    ],
    businessDataFormContext?.data ?? {}
  );

  let fakturadelNewValue: IFormData = {};
  if (returnToUtredningValue === ReturnToUtredningEnum.withoutAttest) {
    fakturadelNewValue = fakturadelStatusUtdelningValue;
  } else {
    if (businessDataFormContext != null) {
      fakturadelNewValue = mergeBusinessDataFormValues(
        getAttesteraFakturadelUpdateValue(
          businessDataFormContext,
          userSign,
          reservFor
        ) ?? {},
        fakturadelStatusUtdelningValue
      );
    }
  }

  businessDataFormContext?.saveForm(
    mergeBusinessDataFormValues(
      fakturadelNewValue,
      getFormUpdateValue(
        attestMessageUpdate,
        businessDataFormContext.data ?? {}
      )
    ),
    () => {
      setOpen(false);
    }
  );
};

const returnFaktura = (
  fakturaDelContext: IFakturaDelContext,
  businessDataFormContext: IBusinessDataFormContext,
  attestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  message: string,
  userSign: string,
  setOpen: (open: boolean) => void,
  returnToUtredningValue: ReturnToUtredningEnum | null,
  reservFor: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined
) => {
  if (returnToUtredningValue != null) {
    returnToUtredning(
      fakturaDelContext,
      businessDataFormContext,
      message,
      userSign,
      setOpen,
      returnToUtredningValue,
      reservFor
    );
  } else {
    returnToAttestant(
      fakturaDelContext,
      businessDataFormContext,
      attestanterToReturnTo,
      message,
      setOpen
    );
  }
};

export const attestanterEquals = (
  attestant1: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  attestant2: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
): boolean =>
  attestant1.AttestantSign === attestant2.AttestantSign &&
  attestant1.AttestTyp === attestant2.AttestTyp;

interface IUseReturnFakturaAttestanter {
  attestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  // autoCheckedAttestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  addAttestant: (
    attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
  ) => void;
  removeAttestant: (
    attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
  ) => void;
  setAttestanterToReturnTo: (
    newValue: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]
  ) => void;
  onEnterKeyDown: () => void;
  onCtrlEnterKeyDown: () => void;
  onReturnFaktura: () => void;
  canReturnFaktura: boolean;
  attestanterSomHarAttesterat: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  autoCheckedAttestanterToReturnTo: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  returnToUtredning: ReturnToUtredningEnum | null;
  setReturnToUtredning: (newValue: ReturnToUtredningEnum | null) => void;
}

export enum ReturnToUtredningEnum {
  withoutAttest = 'WithoutAttest',
  withAttest = 'WithAttest',
}

export const useReturnFakturaAttestanter = (
  message: string,
  messageInputRef: React.MutableRefObject<HTMLInputElement | null>,
  setOpen: (open: boolean) => void
): IUseReturnFakturaAttestanter => {
  const fakturaDelContext = useContext(FakturaDelContext);
  const businessDataFormContext = useContext(BusinessDataFormContext);
  const loginStateContext = useContext(LoginStateContext);
  const reservForContext = useContext(FakturaattestWrapperContext);

  const [attestanterToReturnTo, setAttestanterToReturnTo] = useState<
    FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]
  >([]);
  const [returnToUtredning, setReturnToUtredning] =
    useState<ReturnToUtredningEnum | null>(null);

  const addAttestant = useCallback(
    (
      attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
    ) => {
      setAttestanterToReturnTo(oldValue => {
        return [...oldValue, attestant];
      });
    },
    [setAttestanterToReturnTo]
  );
  const removeAttestant = useCallback(
    (
      attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
    ) => {
      setAttestanterToReturnTo(oldValue => {
        const index = oldValue.findIndex(oldValueItem =>
          attestanterEquals(oldValueItem, attestant)
        );

        return remove(index, 1, oldValue);
      });
    },
    [setAttestanterToReturnTo]
  );

  const attestanterSomHarAttesterat = [
    ...(fakturaDelContext.getAttestanter(
      TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST
    ) ?? []),
    ...(fakturaDelContext.getAttestanter(
      TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
    ) ?? []),
    ...(fakturaDelContext.getAttestanter(
      TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
    ) ?? []),
  ].filter(attest => attest.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD);

  const autoCheckedAttestanterToReturnTo = getAutoCheckedAttestanterToReturnTo(
    attestanterToReturnTo,
    attestanterSomHarAttesterat
  );

  const onReturnFaktura = useCallback(() => {
    const attestanterToReturnToWithAuto = uniqWith(
      attestanterEquals,
      attestanterToReturnTo.concat(autoCheckedAttestanterToReturnTo)
    );

    returnFaktura(
      fakturaDelContext,
      businessDataFormContext,
      attestanterToReturnToWithAuto,
      message,
      loginStateContext.sign,
      setOpen,
      returnToUtredning,
      reservForContext.reservForData
    );
  }, [
    attestanterToReturnTo,
    autoCheckedAttestanterToReturnTo,
    fakturaDelContext,
    businessDataFormContext,
    message,
    loginStateContext.sign,
    setOpen,
    returnToUtredning,
    reservForContext.reservForData,
  ]);

  const canReturnFaktura =
    Boolean(message) &&
    !businessDataFormContext?.mutationLoading &&
    (attestanterToReturnTo.length > 0 || returnToUtredning != null);

  const onEnterKeyDown = useCallback(() => {
    if (
      messageInputRef.current &&
      document.activeElement !== messageInputRef.current &&
      canReturnFaktura
    ) {
      onReturnFaktura();
    }
  }, [messageInputRef, canReturnFaktura, onReturnFaktura]);

  const onCtrlEnterKeyDown = useCallback(() => {
    if (
      messageInputRef.current &&
      document.activeElement === messageInputRef.current &&
      canReturnFaktura
    ) {
      onReturnFaktura();
    }
  }, [messageInputRef, canReturnFaktura, onReturnFaktura]);

  return {
    attestanterToReturnTo,
    addAttestant,
    removeAttestant,
    setAttestanterToReturnTo,
    onEnterKeyDown,
    onCtrlEnterKeyDown,
    onReturnFaktura,
    canReturnFaktura,
    attestanterSomHarAttesterat,
    autoCheckedAttestanterToReturnTo,
    returnToUtredning,
    setReturnToUtredning,
  };
};
